<div class="container-fluid">
  @if (!showOtp) {
    <div class="row">
      <div class="col-xl-4 col-lg-3 col-md-2"></div>
      <div class="col-xl-4 col-lg-6 col-md-8 col-s-12">
        <div class="card mb-3">
          <div class="card-header">
            <fa-icon [icon]="['fas', 'mobile-alt']" size="lg" class="me-2" [fixedWidth]="true"></fa-icon>{{ 'label.mobilt-bankid' | translate }}
          </div>
          <div class="card-body">
            <div class="mb-0">
              <button class="btn-garanti btn-pink w-100" (click)="loginMobileBankId()">
                {{ 'button.bankid-logga-in-med-mobil' | translate }}
                @if (!isMobile) {
                  ({{ 'label.inloggning-med-qr' | translate }})
                }
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  }
  @if (!isMobile && !showOtp) {
    <div class="row">
      <div class="col-xl-4 col-lg-3 col-md-2"></div>
      <div class="col-xl-4 col-lg-6 col-md-8 col-s-12">
        <div class="card mb-3">
          <div class="card-header">
            <fa-icon [icon]="['fas', 'computer']" size="lg" class="me-2" [fixedWidth]="true"></fa-icon>{{ 'label.bankid-pa-dator' | translate }}
          </div>
          <div class="card-body">
            <button class="btn-garanti btn-pink w-100" (click)="loginBankIdOnFile()">
              {{ 'button.bankid-starta' | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  }
  @if (showOtp && !isCreditor) {
    <div class="row">
      <div class="col-xl-4 col-lg-3 col-md-2"></div>
      <div class="col-xl-4 col-lg-6 col-md-8 col-s-12">
        <div class="card mb-3">
          <div class="card-header">
            <fa-icon [icon]="['fas', 'key']" size="lg" class="me-2" [fixedWidth]="true"></fa-icon>{{ 'label.engangskod' | translate }}
          </div>
          <div class="card-body">
            <p class="text-muted">{{ 'label.engangskod-kommer-att-skickas' | translate }}</p>
            <form [formGroup]="loginWithOtpForm" (ngSubmit)="openOtpModal()">
              <div class="mb-3">
                <label for="personal_number">{{ 'label.person-eller-samordningsnr' | translate }}</label>
                <div class="input-group mb-3">
                  <span class="input-group-text">
                      <fa-icon [icon]="['fas', 'passport']" transform="grow-6" [fixedWidth]="true"></fa-icon>
                    </span>
                  <input type="text" name="personal_number_otp" id="personal_number_otp" class="form-control rounded-end" [attr.placeholder]="'placeholder.person-eller-samordningsnr' | translate" formControlName="personal_number_otp" [class.is-invalid]="personal_number_otp.dirty && personal_number_otp.invalid">
                  <div class="invalid-tooltip">
                    @if (personal_number_otp.errors?.isEmpty) {
                      <span>{{ 'label.ogiltigt-personnr-tomt' | translate }}</span>
                    }
                    @if (personal_number_otp.errors?.invalidBirthday) {
                      <span>{{ 'label.ogiltigt-personnr-fodelsedag' | translate }}</span>
                    }
                    @if (personal_number_otp.errors?.invalidFormat) {
                      <span>{{ 'label.ogiltigt-personnr-format' | translate }}</span>
                    }
                    @if (personal_number_otp.errors?.invalidCheckDigit) {
                      <span>{{ 'label.ogiltigt-personnr-checksiffra' | translate }}</span>
                    }
                  </div>
                </div>
              </div>
              <div class="mb-0">
                <div class="checkbox me-2">
                  <label>
                    <input type="checkbox" name="remember_personal_number_otp" id="remember_personal_number_otp" class="form-check-input" formControlName="remember_personal_number_otp">
                    <span class="cr me-2"><fa-icon [icon]="['fas', 'check']" transform="grow-3" class="cr-icon"></fa-icon></span>
                    {{ 'label.kom-ihag-person-eller-samordningsnummer' | translate }}
                  </label>
                </div>
              </div>
              <input class="btn-garanti btn-pink w-100" type="submit" [attr.value]="'button.starta' | translate" [disabled]="loginWithOtpForm.invalid" />
            </form>
          </div>
        </div>
      </div>
    </div>
  }
  @if (!showOtp && !registrationCode && !isCreditor) {
    <div class="row">
      <div class="col-xl-4 col-lg-3 col-md-2"></div>
      <div class="col-xl-4 col-lg-6 col-md-8 col-s-12">
        <div class="card">
          <div class="card-body">
            <button class="btn-garanti btn-blue w-100 p-3" (click)="toggleShowOtp()">
              <span class="h5">
                <fa-icon [icon]="['fas', 'circle-question']" class="me-2"></fa-icon>
                {{ 'button.jag-saknar-bankid' | translate }}
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  }
</div>
